import { reactive, computed, onBeforeMount, watch } from '@vue/composition-api'
import { formatDate, breakComma, isPc } from '@/util/common'
import * as _ from 'lodash'

export const BookmarkDeleteConfirm = (props, context) => {
  const store = context.root.$store
  const { bookmark } = store.state

  const close = () => {
    context.emit('closeBookmarkDeleteConfirm')
  }
  const submit = async() => {
    const params = {
      id: bookmark.currentId
    }
    await store
      .dispatch('bookmark/delete', params)
      .then(() => {
        store.dispatch('common/showToast', {
          text: 'ブックマークを削除しました'
        })
        store.dispatch('bookmark/getTags')
      })
    context.emit('closeBookmarkDeleteConfirm')
  }
  
  return {
    close,
    submit
  }
}
